import { Res } from 'api/api.types';
import { axiosInstance } from 'api/axios';

export const getOrdersCount = async () =>
  await axiosInstance.get<Res<number>>('/order/count');
